import TealiumUniversalTag from "../lib/TealiumUniversalTag";

export default class TealiumWithGlobalData {
  private tealium: TealiumUniversalTag;
  private store: Record<string, unknown>;

  constructor(tealium: TealiumUniversalTag) {
    this.tealium = tealium;
    this.store = {};
  }

  public setGlobally(key: string, value: unknown): void {
    this.store[key] = value;
  }

  public pageView(data: Record<string, unknown>): void {
    void this.tealium.pageView("Page view", {
      ...this.store,
      ...data,
    });
  }

  public track(event: string, data: Record<string, unknown>): void {
    void this.tealium.track(event, {
      ...this.store,
      ...data,
    });
  }

  public link(data: Record<string, unknown>): void {
    void this.tealium.track("link_click", {
      ...this.store,
      ...data,
    });
  }
}
